module.exports = __webpack_public_path__ + "static/image6-f22493bdd45787fd34503da1d6e719b4.png";